// components/ProjectCreationConfirmationDialog.jsx

import React from 'react';

const ProjectCreationConfirmationDialog = ({ 
  isOpen, 
  onClose, 
  onProceedToCopy, 
  projectName 
}) => {
  // Dialog styles matching CreateProjectDialog
  const dialogStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1100,
      padding: '20px'
    },
    dialog: {
      backgroundColor: 'white',
      borderRadius: '8px',
      width: '450px',
      maxWidth: '90vw',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    },
    header: {
      backgroundColor: '#CCCCFF',
      textAlign: 'center',
      padding: '15px 20px',
      borderRadius: '8px 8px 0 0',
      fontSize: '18px',
      fontWeight: 'bold',
      flexShrink: 0
    },
    content: {
      padding: '30px 20px',
      textAlign: 'center'
    },
    footer: {
      padding: '15px 20px',
      borderTop: '1px solid #e5e7eb',
      backgroundColor: '#f9fafb',
      borderRadius: '0 0 8px 8px',
      flexShrink: 0
    }
  };

  if (!isOpen) return null;

  return (
    <div style={dialogStyles.overlay}>
      <div style={dialogStyles.dialog}>
        {/* Fixed Header */}
        <div style={dialogStyles.header}>
          Project Created Successfully
        </div>

        {/* Content */}
        <div style={dialogStyles.content}>
          {/* Success Icon */}
          <div style={{ marginBottom: '20px' }}>
            <svg width="64" height="64" fill="none" stroke="#059669" viewBox="0 0 24 24" style={{ margin: '0 auto' }}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          {/* Success Message */}
          <h3 style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#059669',
            marginBottom: '16px'
          }}>
            Project Successfully Created
          </h3>

          {projectName && (
            <p style={{
              fontSize: '16px',
              color: '#374151',
              marginBottom: '24px'
            }}>
              Project "<strong>{projectName}</strong>" has been created successfully.
            </p>
          )}

          <p style={{
            fontSize: '14px',
            color: '#6b7280',
            lineHeight: '1.5'
          }}>
            To get started quickly, you can copy configuration data from an existing project. 
            This will help set up your new project with essential settings and configurations.
          </p>
        </div>

        {/* Fixed Footer */}
        <div style={dialogStyles.footer}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>

            
            <button
              onClick={onProceedToCopy}
              style={{
                padding: '10px 20px',
                backgroundColor: '#C8F4DE',
                color: 'black',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 'bold'
              }}
            >
              Proceed to copying data from another project
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCreationConfirmationDialog;